import {  createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IArea } from "core/interfaces/data/IAreaRequest";
import { IAssistito, IFamiliare } from "core/interfaces/data/IAssistitoRequest";
import { ITariffa } from "core/interfaces/data/IDataPreventivoRequest";
import { ILuogoErogazione } from "core/interfaces/data/ILuogoErogazione";
import { IPrestazione } from "core/interfaces/data/IPrestazioneRequest";
import { IProfessionista } from "core/interfaces/data/IProfessionistiRequest";
import { RootState } from "../../store/store";
import { IDataFormState,  IOrarioProfessionistaSlice,  IOrarioSlice, IRegisterDataSlice, IResultPrenotazioneDataSlice } from "./dataFormSliceInterfaces";

const initialState: IDataFormState = {
	data: {
		area: undefined,
		prestazione: undefined,
		tariffa: undefined,
		professionista: undefined,
		orario: undefined,
		registerData: undefined,
		destinatarioAssistenza: undefined,
		resultPrenotazione: undefined,
	},

	status: "idle",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
// export const incrementAsync = createAsyncThunk("dataForm/fetchDataForm", async (dataForm: IDataFormSlice) => {
// 	const response = await fetchDataForm(dataForm);
// 	// The value we return becomes the `fulfilled` action payload
// 	return response.data;
// });

export const dataFormSlice = createSlice({
	name: "dataForm",
	initialState,
	// The `reducers` field lets us define reducers and generate associated actions
	reducers: {
		setArea: (state: IDataFormState, action: PayloadAction<IArea>) => {
			state.data.area = action.payload;
		},
		setIndirizzo: (state: IDataFormState, action: PayloadAction<string>) => {
			if (state.data.area && state.data.area.LuogoErogazione) {
				state.data.area.LuogoErogazione.Via = action.payload;
				state.data.area.LuogoErogazione.Civico = "";
			}
		},
		setLuogoErogazione: (state: IDataFormState, action: PayloadAction<ILuogoErogazione | undefined>) => {
			if (state.data.area) state.data.area.LuogoErogazione = action.payload;
		},
		setPrestazione: (state: IDataFormState, action: PayloadAction<IPrestazione>) => {
			state.data.prestazione = action.payload;
		},

		setTariffa: (state: IDataFormState, action: PayloadAction<ITariffa | undefined>) => {
			state.data.tariffa = action.payload;
		},

		setProfessionista: (state: IDataFormState, action: PayloadAction<IProfessionista>) => {
			state.data.professionista = action.payload;
		},
		setOrario: (state: IDataFormState, action: PayloadAction<IOrarioProfessionistaSlice | undefined>) => {
			state.data.orario = action.payload? {Da:action.payload?.Da,A:action.payload?.A} as IOrarioSlice:undefined;
			// if (state.data.professionista && state.data.professionista.IdOperatore === -1 && action.payload?.Professionista) {
				//-->PERCHè si limitava l'assegnamento a quando preesisteva un professionista ed era a -1?? Per verificare che il passo precedente avesse predisposto le cose?
			if (state.data.professionista && action.payload?.Professionista) {
				state.data.professionista=action.payload?.Professionista;
			}
		},

		setRegisterData: (state: IDataFormState, action: PayloadAction<IRegisterDataSlice>) => {
			state.data.registerData = action.payload;
		},

		setDestinatarioAssistenza: (state: IDataFormState, action: PayloadAction<IAssistito | IFamiliare | undefined>) => {
			state.data.destinatarioAssistenza = action.payload;
		},

		resetRegisterData: (state: IDataFormState) => {
			state.data.registerData = undefined;
		},

		setResoultPrenotazione: (state: IDataFormState, action: PayloadAction<IResultPrenotazioneDataSlice | undefined>) => {
			state.data.resultPrenotazione = action.payload;
		},

		resetDataForm: (state: IDataFormState) => {
			state.data.area = undefined;
			state.data.prestazione = undefined;
			state.data.tariffa = undefined;
			state.data.professionista = undefined;
			state.data.orario = undefined;
			state.data.registerData = undefined;
			state.data.resultPrenotazione = undefined;
			state.data.destinatarioAssistenza = undefined;
		},
	},
	// The `extraReducers` field lets the slice handle actions defined elsewhere,
	// including actions generated by createAsyncThunk or in other slices.
	// extraReducers: (builder) => {
	// 	builder
	// 		.addCase(incrementAsync.pending, (state) => {
	// 			state.status = "loading";
	// 		})
	// 		.addCase(incrementAsync.fulfilled, (state, action) => {
	// 			state.status = "idle";
	// 			state.data = action.payload;
	// 		})
	// 		.addCase(incrementAsync.rejected, (state) => {
	// 			state.status = "failed";
	// 		});
	// },
});

export const {
	setArea,
	setIndirizzo,
	setLuogoErogazione,
	setPrestazione,
	setProfessionista,
	setTariffa,
	resetDataForm,
	setOrario,
	setRegisterData,
	setResoultPrenotazione,
	setDestinatarioAssistenza,
	resetRegisterData,
} = dataFormSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectFormData = (state: RootState) => state.dataForm.data;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd =
// 	(amount: number): AppThunk =>
// 	(dispatch, getState) => {
// 		const currentValue = selectCount(getState());
// 		if (currentValue % 2 === 1) {
// 			dispatch(incrementByAmount(amount));
// 		}
// 	};


export default dataFormSlice.reducer;
